import { SET_FILE_STORAGE, SET_FILES, CLEAR_FILE_STORAGE } from './fileStorageTypes';

const initialState = {
    currentFileStorage: {},
    currentFiles: {},
    loading: false,
    error: null
};

export default function fileStorageReducer(state = initialState, action) {
    switch (action.type) {
        case SET_FILE_STORAGE:
            return { ...state, currentFileStorage: action.payload };
        case SET_FILES:
            return { ...state, currentFiles: action.payload };
        case CLEAR_FILE_STORAGE:
            return initialState;
        default:
            return state;
    }
}
